import React, { useEffect, useRef, useState } from 'react';
import { useWallet } from '../../context/WalletContext';
import { useContracts } from '../../context/ContractContext';
import Card from '../common/Card';
import InlineLoader from '../common/InlineLoader';
import { formatUSDT, formatDateShort, withdrawStatusLabel, withdrawStatusBadge } from '../../utils/format';

const PAGE = 10;

export default function WithdrawHistory({ refreshFlag }) {
  const { account } = useWallet();
  const { main, views } = useContracts();
  const [loading, setLoading] = useState(true);
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [pg, setPg] = useState(0);
  const mountedRef = useRef(true);

  useEffect(() => {
    mountedRef.current = true;
    if (!account) { setLoading(false); return; }
    const load = async () => {
      try {
        const uid = await main.addrToId(account);
        if (uid.eq(0)) { if (mountedRef.current) setLoading(false); return; }
        const res = await views.getUserWithdraws(uid, pg, PAGE);
        if (!mountedRef.current) return;
        const rows = [];
        const totalNum = Number(res.total.toString());
        for (let i = 0; i < res.ids.length; i++) {
          rows.push({
            id: res.ids[i].toString(),
            amount: res.amounts[i],
            requestedAt: res.requestedAts[i],
            processedAt: res.processedAts[i],
            status: Number(res.statuses[i])
          });
        }
        setItems(rows);
        setTotal(totalNum);
        setLoading(false);
      } catch (_) {
        if (mountedRef.current) setLoading(false);
      }
    };
    setLoading(true);
    load();
    return () => { mountedRef.current = false; };
  }, [account, main, views, pg, refreshFlag]);

  const totalPages = Math.max(1, Math.ceil(total / PAGE));

  if (loading) return <Card title="My Withdrawal Requests"><InlineLoader /></Card>;
  if (!account) return <Card title="My Withdrawal Requests"><div className="empty-state">Connect wallet</div></Card>;
  if (items.length === 0) return <Card title="My Withdrawal Requests"><div className="empty-state">No withdrawal requests yet</div></Card>;

  return (
    <Card title={`My Withdrawal Requests (${total})`}>
      <div className="table-wrap table-scroll">
        <table className="table">
          <thead>
            <tr>
              <th>Req #</th>
              <th className="text-right">Amount</th>
              <th>Requested</th>
              <th>Processed</th>
              <th className="text-center">Status</th>
            </tr>
          </thead>
          <tbody>
            {items.map((it) => (
              <tr key={it.id}>
                <td className="text-primary">#{it.id}</td>
                <td className="text-right">${formatUSDT(it.amount)}</td>
                <td>{formatDateShort(it.requestedAt)}</td>
                <td>{Number(it.processedAt) > 0 ? formatDateShort(it.processedAt) : '—'}</td>
                <td className="text-center">
                  <span className={`badge ${withdrawStatusBadge(it.status)}`}>
                    {withdrawStatusLabel(it.status)}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {totalPages > 1 && (
        <div className="pagination">
          <button className="page-btn" disabled={pg === 0} onClick={() => setPg((p) => Math.max(0, p - 1))}>← PREV</button>
          <span className="page-info">Page {pg + 1} / {totalPages}</span>
          <button className="page-btn" disabled={pg >= totalPages - 1} onClick={() => setPg((p) => p + 1)}>NEXT →</button>
        </div>
      )}
    </Card>
  );
}
